import MyIcon from '@/components/MyIcon';

import { Tooltip } from 'antd';
const FeedBack = (props) => {
    const { side = 'web', className, onClick } = props;
    return (
        <>
            <Tooltip zIndex={1} title={side === 'mobile' ? null : '反馈'}>
                <span className={className} onClick={onClick}>
                    <MyIcon className="ai-action-icon" type="icon-fankui"></MyIcon>
                </span>
            </Tooltip>
        </>
    );
};
export default FeedBack;
